<template>
  <div v-if="periods && period">
    <div class="not-printable text-right">
      <v-btn class="v-primary" @click="openPrintDialog">
        <i class="fa fa-print" /> IMPRIMIR
      </v-btn>
    </div>

    <table class="table-important">
      <thead>
        <tr>
          <td>
            <div class="header-space">
              <div style="page-break-after: always !important">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <img
                      style="
                        height: 80px !important;
                        object-fit: cover !important;
                      "
                      v-if="rest_home.logo_url"
                      class="rest_home_logo_url"
                      :src="rest_home.logo_url"
                    />
                    <div v-if="!rest_home.logo_url" class="ml-1">
                      <strong class="text-uppercase">{{
                        rest_home.name
                      }}</strong>
                    </div>
                  </div>
                  <div>
                    <img
                      width="150px"
                      height="30px"
                      :src="require('../../../assets/logo.png')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="content">
              <div class="custom-table">
                <b-row no-gutters>
                  <b-col>
                    CLIENTE <br />
                    {{ rest_home.name }}
                  </b-col>
                  <b-col cols="auto">
                    CNPJ <br />
                    {{ rest_home.cnpj }}
                  </b-col>
                </b-row>
                <b-row no-gutters>
                  <b-col>
                    ENDEREÇO <br />
                    {{ rest_home.address }}
                  </b-col>
                  <b-col cols="auto">
                    NÚMERO <br />
                    {{ rest_home.num_address }}
                  </b-col>
                </b-row>
                <b-row no-gutters>
                  <b-col>
                    CEP <br />
                    {{ rest_home.cep }}
                  </b-col>
                  <b-col>
                    BAIRRO <br />
                    {{ rest_home.neighborhood }}
                  </b-col>
                  <b-col>
                    CIDADE <br />
                    {{ rest_home.city }}
                  </b-col>
                  <b-col>
                    ESTADO <br />
                    {{ rest_home.uf }}
                  </b-col>
                </b-row>
              </div>

              <div class="custom-table">
                <b-row no-gutters>
                  <b-col>
                    EMITIDO <br />
                    {{ formatDate(now) }}
                  </b-col>
                  <b-col>
                    PERÍODO <br />
                    {{ formatDate(period.start, false) }} -
                    {{ formatDate(period.end, false) }}
                  </b-col>
                  <b-col>
                    PAGAMENTO <br />
                    {{ formatDate(period.payment_date_start, false) }} -
                    {{ formatDate(period.payment_date_end, false) }}
                  </b-col>
                  <b-col>
                    RESIDENTES <br />
                    {{ period.residents.length }}
                  </b-col>
                  <b-col>
                    VALOR TOTAL RESIDENTES<br />
                    {{ formatBRLCurrency(period.payment_value) }}
                  </b-col>
                </b-row>
              </div>

              <div
                v-if="
                  boleto_amount > 0 &&
                  boleto_value > 0 &&
                  boleto_payment_value > 0
                "
              >
                <div class="custom-table">
                  <b-row no-gutters>
                    <b-col>
                      QUANTIDADE DE BOLETOS EMITIDOS
                      <br />
                      {{ boleto_amount }}
                    </b-col>
                    <b-col>
                      VALOR COBRADO POR BOLETO
                      <br />
                      {{ formatBRLCurrency(boleto_value) }}
                    </b-col>
                    <b-col>
                      VALOR TOTAL DE BOLETOS EMITIDOS <br />
                      {{ formatBRLCurrency(boleto_payment_value) }}
                    </b-col>
                    <b-col> </b-col>
                    <b-col strong>
                      <strong
                        >VALOR TOTAL SOMADO <br />
                        {{
                          formatBRLCurrency(
                            period.payment_value + boleto_payment_value
                          )
                        }}
                      </strong>
                    </b-col>
                  </b-row>
                </div>
              </div>

              <v-data-table
                dense
                :headers="active_resident_headers"
                :items="period.residents"
                hide-default-footer
                disable-pagination
                disable-sort
              >
                <template #[`item.start_date`]="{ item }">
                  {{ formatDate(item.start_date, false) }}
                </template>
                <template #[`item.end_date`]="{ item }">
                  {{ formatDate(item.end_date, false) }}
                </template>
                <template #[`item.days`]="{ item }">
                  {{ item.days.length }}
                </template>
                <template #[`item.total`]="{ item }">
                  {{ formatBRLCurrency(item.total) }}
                </template>
                <template #[`body.append`]="{}">
                  <tr>
                    <td>TOTAL: {{ period.residents.length }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      TOTAL: {{ formatBRLCurrency(period.payment_value) }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <ErrorsMessages :errors="errors" class="not-printable" />
  </div>
</template>

<script>
import ErrorsMessages from "../../components/ErrorsMessages";

import { formatBRLCurrency } from "../../../lib/functions";

import api from "../../../services/api";

import { formatDate } from "../../../functions/format";

export default {
  name: "RestHomeCharge",

  components: {
    ErrorsMessages,
  },

  data() {
    return {
      errors: [],

      now: new Date(),

      loading: false,

      periods: null,

      period: null,

      charge_period: 1,

      active_resident_headers: [
        { text: "NOME", value: "name" },
        { text: "DATA INICIAL", value: "start_date" },
        { text: "DATA FINAL", value: "end_date" },
        { text: "DIAS ATIVO", value: "days" },
        { text: "VALOR", value: "total" },
      ],

      rest_home: {},

      boleto_payment_value: 0,

      boleto_value: 0,

      boleto_amount: 0,
    };
  },

  props: {
    year: [String, Number],
    month: [String, Number],
    props_charge_period: [String, Number],
    rest_home_id: [String, Number],
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatBRLCurrency,
    formatDate,

    async retrieve() {
      await this.getRestHome();
      await this.getPeriods();
      await this.getPeriod();
      await this.getInformationBoleto();
    },

    async openPrintDialog() {
      window.print();
    },

    async getRestHome() {
      try {
        let { rest_home_id } = this;

        const params = { id: rest_home_id };

        const response = await api.get("/admin/rest-home/get", { params });

        const { error, errors, restHome } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.rest_home = restHome;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async getPeriods() {
      try {
        this.loading = true;

        let { rest_home_id, props_charge_period } = this;

        const params = {
          rest_home_id,
          filter_charge_period: props_charge_period,
        };

        let response = await api.get("/admin/rest-home/charge/periods", {
          params,
        });

        let { error, errors, periods } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];

          if (periods) {
            this.periods = periods;

            this.p_years = Object.keys(this.periods);
            this.year = this.p_years[this.p_years.length - 1];

            this.p_months = Object.keys(this.periods[this.year]);
            this.month = this.p_months[this.p_months.length - 1];

            this.p_periods = this.periods[this.year][this.month];
            this.charge_period = this.p_periods[this.p_periods.length - 1].id;
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getPeriod() {
      try {
        this.loading = true;

        let { rest_home_id, charge_period } = this;

        let params = { rest_home_id, charge_period };

        let response = await api.get("/admin/rest-home/charge/period", {
          params,
        });

        let { error, errors, period } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];

          if (period) {
            this.period = period;

            this.period.start = new Date(period.start);

            this.period.end = new Date(period.end);

            this.period.payment_date_start = new Date(
              period.payment_date_start
            );

            this.period.payment_date_end = new Date(period.payment_date_end);

            this.$emit("period_payment_value", period.payment_value);
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getInformationBoleto() {
      try {
        this.loading = true;

        const { rest_home_id, props_charge_period } = this;

        const params = { rest_home_id, date: props_charge_period };

        const response = await api.get("/admin/rest-home/charge/period/boleto", {
          params,
        });

        const { boleto_payment_value, boleto_value, total, error } = response.data;

        if (error) {
          this.errors = [];
        } else {
          if ((boleto_payment_value, boleto_value, total)) {
            this.boleto_payment_value = boleto_payment_value;
            this.boleto_value = boleto_value;
            this.boleto_amount = total;

            this.$emit("boleto_period_payment_value", boleto_payment_value);
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    padding(n) {
      return n < 10 ? `0${n}` : String(n);
    },
  },
};
</script>

<style scoped>
.header {
  display: block !important;
}

table,
td,
th,
tfoot {
  width: 100% !important;
  cursor: auto !important;
}

.header {
  position: fixed;
  top: 0;
}

.table-important {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  cursor: auto !important;
}

.rest_home_logo_url {
  height: 30px;
  width: 100%;
  object-fit: contain;
}

@media print {
  @page {
    size: 0;
  }

  .table-important {
    page-break-after: always !important;
    page-break-inside: avoid !important;
  }

  .content {
    page-break-before: always !important;
  }

  .page-break-inside-avoid {
    page-break-inside: avoid !important;
  }

  .not-printable {
    display: none;
  }
}

.data-manual {
  font-family: monospace;
  font-size: 20px;
}

.custom-table > .row {
  border-top: 1px solid black;
}
.custom-table > .row:last-child {
  border-bottom: 1px solid black;
}

.custom-table > .row > .col,
.custom-table > .row > .col-auto {
  padding-left: 10px;
  border-left: 1px solid black;
}
.custom-table > .row > .col-auto {
  padding-right: 10px;
}
.custom-table > .row > .col:last-child,
.custom-table > .row > .col-auto:last-child {
  padding-right: 10px;
  border-right: 1px solid black;
}
</style> 